export default __webpack_public_path__ + "fonts/Divorce-White.svg";